import { Grid } from "@material-ui/core";
import { InputOptionMaster } from "App/Component/ui";
import {
  PILIH_ASSESMENT_PELAYANAN_SELAIN_NORMAL,
  TUJUAN_KUNJUNGAN_NORMAL,
} from "../constants";
import React from "react";

export const AssesmentPelayananRawatJalan = ({
  formData,
  handleChange,
  type,
}) => {
  if (type === "RJ") {
    return (
      <>
        {formData.tujuan_kunjungan !== TUJUAN_KUNJUNGAN_NORMAL && (
          <Grid item sm={4}>
            <InputOptionMaster
              name='assesment_pel'
              label='ASSESMENT PELAYANAN'
              id='assesment_pel'
              value={formData.assesment_pel}
              onChange={handleChange("assesment_pel")}
              data={PILIH_ASSESMENT_PELAYANAN_SELAIN_NORMAL}
              placeholder=''
            />
          </Grid>
        )}
      </>
    );
  } else {
    return <></>;
  }
};
